import { fromJS, Map } from 'immutable';

import {
  REQUEST_COMBO_UPSELLS,
  REQUEST_COMBO_UPSELLS_SUCCESS,
  REQUEST_COMBO_UPSELLS_FAILURE,
} from 'actions/comboUpsells/constants';

const comboUpsells = (state = new Map(), action) => {
  switch (action.type) {
    case REQUEST_COMBO_UPSELLS: {
      return state
        .merge(
          fromJS({
            loadingComboUpsells: true,
            originalSectionProductId: null,
            errorLoadingComboUpsells: false,
          })
        )
        .update('upsellSectionProducts', current => (Map.isMap(current) ? current : new Map()));
    }

    case REQUEST_COMBO_UPSELLS_SUCCESS: {
      const { sectionProductId, upsellSectionProducts } = action.payload;

      return state
        .merge(
          fromJS({
            loadingComboUpsells: false,
            originalSectionProductId: sectionProductId,
            errorLoadingComboUpsells: false,
          })
        )
        .update('upsellSectionProducts', current => (Map.isMap(current) ? current : new Map()))
        .setIn(['upsellSectionProducts', String(sectionProductId)], fromJS(upsellSectionProducts));
    }

    case REQUEST_COMBO_UPSELLS_FAILURE:
      return state.merge(
        fromJS({
          loadingComboUpsells: false,
          errorLoadingComboUpsells: true,
        })
      );

    default:
      return state;
  }
};

export default comboUpsells;
